/**
 * SONKUKI — recently viewed products (localStorage)
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'sonkuki_recently_viewed';
  var MAX_STORED = 8;

  function formatMoney(cents) {
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function readStore() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function writeStore(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {
      /* quota / private mode */
    }
  }

  function trackCurrentProduct() {
    var el = document.querySelector('[data-current-product]');
    if (!el) return;

    var product;
    try {
      product = JSON.parse(el.textContent);
    } catch (e) {
      return;
    }
    if (!product || !product.id) return;

    var items = readStore().filter(function (item) {
      return item.id !== product.id;
    });
    items.unshift({
      id: product.id,
      handle: product.handle,
      title: product.title,
      url: product.url,
      image: product.image || '',
      price: product.price,
      compare_at_price: product.compare_at_price || 0
    });
    writeStore(items.slice(0, MAX_STORED));
  }

  function buildCard(item) {
    var onSale =
      item.compare_at_price && item.compare_at_price > item.price;
    var discount = '';
    if (onSale) {
      discount =
        '-' +
        Math.round(
          ((item.compare_at_price - item.price) / item.compare_at_price) *
            100
        ) +
        '%';
    }

    var card = document.createElement('a');
    card.href = item.url;
    card.className = 'product-card';
    card.title = item.title;
    card.innerHTML =
      '<div class="product-card__media">' +
      (item.image
        ? '<img src="' +
          item.image +
          '" alt="" loading="lazy" width="400" height="400">'
        : '') +
      (onSale
        ? '<span class="product-card__badge">' + discount + '</span>'
        : '') +
      '</div>' +
      '<div class="product-card__body">' +
      '<h3 class="product-card__title">' +
      item.title +
      '</h3>' +
      '<div class="product-card__footer">' +
      '<div class="product-card__prices">' +
      '<span class="product-card__price">' +
      formatMoney(item.price) +
      '</span>' +
      (onSale
        ? '<span class="product-card__compare">' +
          formatMoney(item.compare_at_price) +
          '</span>'
        : '') +
      '</div>' +
      '<span class="product-card__arrow" aria-hidden="true">↗</span>' +
      '</div>' +
      '</div>';

    var wrap = document.createElement('div');
    wrap.setAttribute('data-reveal', '');
    wrap.appendChild(card);
    return wrap;
  }

  function renderRecentlyViewed() {
    var section = document.querySelector('[data-recently-viewed-section]');
    if (!section) return;

    var grid = section.querySelector('[data-recently-viewed-grid]');
    if (!grid) return;

    var limit = parseInt(section.dataset.limit, 10) || 4;
    var excludeId = null;
    var currentEl = document.querySelector('[data-current-product]');
    if (currentEl) {
      try {
        excludeId = JSON.parse(currentEl.textContent).id;
      } catch (e) {
        excludeId = null;
      }
    }

    var items = readStore().filter(function (item) {
      return excludeId == null || item.id !== excludeId;
    });

    if (!items.length) {
      section.hidden = true;
      return;
    }

    grid.innerHTML = '';
    items.slice(0, limit).forEach(function (item) {
      grid.appendChild(buildCard(item));
    });
    section.hidden = false;
  }

  function init() {
    trackCurrentProduct();
    renderRecentlyViewed();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
